import { render, staticRenderFns } from "./Extrato.vue?vue&type=template&id=65cd7e5c&scoped=true"
import script from "./Extrato.vue?vue&type=script&lang=js"
export * from "./Extrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd7e5c",
  null
  
)

export default component.exports